module.exports = __webpack_public_path__ + "static/media/cancelReq1.1a0dc460.svg";